import { Fragment } from "react";
import cn from "classnames";

const ToggleVisibility = ({ children, isVisible, collapse, as, ...props }) => {
  let Component = as ? as : Fragment;

  if (!collapse)
    return isVisible && <Component {...props}>{children}</Component>;

  return (
    <div className={cn(props.className, { collapse: !isVisible })} {...props}>
      {children}
    </div>
  );
};

export default ToggleVisibility;
